<div class="za-dialog">

  <!-- Header -->
  <div class="za-header">
    <div class="za-title-wrap">
      <div class="za-title-icon">
        <mat-icon>grid_view</mat-icon>
      </div>
      <div class="za-title-text">
        <h2 class="za-title">Assign zones</h2>
        <div class="za-subtitle">{{phase.phaseName}} &middot; place this phase's plants into your zones</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="za-close" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <mat-dialog-content class="za-body">
    <app-zone-allocate [strains]="phase.strains"></app-zone-allocate>
  </mat-dialog-content>

  <!-- Footer -->
  <div class="za-footer">
    <span class="za-footer-note">{{summary}}</span>
    <div class="za-footer-actions">
      <button mat-button mat-dialog-close class="za-btn-ghost">Cancel</button>
      <button type="button" class="za-btn-primary" (click)="savephaseZone()">
        <span>Save zones</span>
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </div>
</div>
